export const UPDATE_TRANSCRIPT_MODAL = "UPDATE_TRANSCRIPT_MODAL";
export const UPDATE_CONFIRMATION_MODAL = "UPDATE_CONFIRMATION_MODAL";
export const ASK_VYRILL_INTRO_MODAL = "ASK_VYRILL_INTRO_MODAL";

export const updateTranscriptModalState = (data) => ({
  type: UPDATE_TRANSCRIPT_MODAL,
  data,
});

export const updateConfirmationModalState = (data) => ({
  type: UPDATE_CONFIRMATION_MODAL,
  data,
});

export const updateAskVyrillIntroModal = (data) => ({
  type: ASK_VYRILL_INTRO_MODAL,
  data,
});
